import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import DashboardLayout from "../../DashboardLayout";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { fetchAdsOnSpecialEvents } from "../../../services/axios/apiManager";
import { handleErrors } from "../../../services/dataManager";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import BSPagination from "../../../Components/pagination";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function SeasonalTrends() {
  const navigation = useNavigate();
 
const tableRef = useRef(null);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [pagination, setPagination] = useState({});

  const getAdsOnSpecialEvents = async (page = 1, pageSize = 10) => {
    const res = await fetchAdsOnSpecialEvents(page, pageSize);
    if (res?.data?.success && res?.data?.data) {
      setTableData(res.data.data);
      if (res?.data?.metadata) {
        setPagination(res.data.metadata);
      }
      if (selectedEvent?.length) {
        const temp = res?.data?.data?.filter((f) => f.p_id === selectedEvent);
        setFilteredData(temp);
      } else {
        setFilteredData(res.data.data);
      }
    } else {
      handleErrors(res, navigation);
    }
  };

  const handleFilterChange = (e) => {
    setSelectedEvent(e.target.value);
    if (e?.target?.value?.length) {
      const temp = tableData.filter((f) => f.p_id == e.target.value);
      setFilteredData(temp);
    } else {
      setFilteredData(tableData);
    }
  };

  const handleReset = () => {
    setSelectedEvent("");
    setFilteredData(tableData);
  };

  const handlePageChange = async (page) => {
    await getAdsOnSpecialEvents(page, pagination.pageSize || 10);
  };
  const chartData = {
    labels: filteredData.map((item) => item.event_name),
    datasets: [
      {
        label: "Ad Views",
        data: filteredData.map((item) => item.ads_watched),
        backgroundColor: "rgba(153, 102, 255, 0.7)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          color: "#ffffff",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#ffffff",
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: "#ffffff",
        },
      },
    },
  };

  useEffect(() => {
    getAdsOnSpecialEvents();
  }, []);

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = filteredData.map((item) => {
      return [
        item.event_name,
        item.start_date && format(item.start_date, "PP"),
        item.end_date && format(item.end_date, "PP"),
        item.ads_watched,
      ];
    });

    const config = {
      data: rows,
      columns: [
        { title: "Event" },
        { title: "Start Date" },
        { title: "End Date" },
        { title: "Ad Views" },
      ],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [filteredData]);
  return (
    <DashboardLayout>
      {/* Filter Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter Seasonal Trends</h5>
          <div className="row align-items-center">
            <div className="col-md-3">
              <Form.Select
                className="bg-dark text-light border-light"
                value={selectedEvent}
                onChange={handleFilterChange}
              >
                <option value="">All holidays</option>
                {tableData?.map((m) => (
                  <option value={m?.p_id}>{m?.event_name || "Event"}</option>
                ))}
              </Form.Select>
            </div>
            <div className="col-md-2">
              <Button className="btn btn-success" onClick={handleReset}>
                Reset
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Seasonal Trends</h5>
          <p className="card-text">
            Compare ad performance during holidays or special events.
          </p>

          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-dark table-striped table-hover w-100"
            />
            {filteredData.length === 0 && (
              <p className="text-center mt-3">No data available.</p>
            )}
          </div>
          <div className="constainer-fluid mt-2">
            <div className="d-flex justify-content-end">
              <div className="mx-4 py-2">
                <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
              </div>
              <BSPagination
                currentPage={parseInt(pagination?.currentPage)}
                totalPages={parseInt(pagination?.totalPages)}
                onPageChange={handlePageChange}
                siblingCount={2}
                showFirstLast={true}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Ad Views by Holiday</h6>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default SeasonalTrends;
